<form [formGroup]="pwForm" (submit)="onSubmitForChange($event)">
  <div class="my-4" *ngIf="requestMfaCode">
    <ng-container>
    @if (showMessage){
      <p class="text-primary mb-5"> A verification code has been sent to your registered email address. </p>
    }</ng-container>
    <mat-form-field class="w-full">
      <mat-label>Verification Code</mat-label>
      <input
        id="verification-code"
        #verificationCodeInput
        matInput
        type="text"
        formControlName="mfaCode"
        (keyup)="checkVerificationCode($event)"
        pattern="[0-9]{6}">
      <mat-error *ngIf="mfaCode.hasError('required')">
        Verification code is required
      </mat-error>
      <mat-error *ngIf="mfaCode.hasError('maxlength')">
        Verification code must be a 6-digit number
      </mat-error>
    </mat-form-field>
    <div class="text-slate-500 text-sm ml-[3px] mt-1">
    </div>
  </div>
  <div class="my-4">
    <mat-form-field
      class="w-full"
      [subscriptSizing]="'dynamic'"
      hideRequiredMarker="true">
      <mat-label>New Password</mat-label>
      <input
        cdkFocusInitial
        type="password"
        matInput
        #newPasswordInput
        formControlName="new_password"
        [spellcheck]="true"
        #bondFamilyLabel
        required
        (blur)="isPasswordValid()" />

      <mat-error
        *ngIf="
          pwForm.get('new_password')?.invalid &&
          pwForm.get('new_password')?.touched
        ">
        New Password must meet the requirements.
      </mat-error>
      <!-- <mat-hint>
        The password must be at least 10 characters, contain UPPERCASE and
        lowercase letters, have no spaces, contain at least 1 number, and must
        also contain at least 1 of these characters: !&#64;#$%^&*()\-_=+{{
          '{}'
        }};:,&lt;.&gt
      </mat-hint> -->
    </mat-form-field>
    <div class="text-slate-500 text-sm ml-[3px] mt-1">
      The password must be at least 10 characters, contain UPPERCASE and
      lowercase letters, have no spaces, contain at least 1 number, and must
      also contain at least 1 of these characters: !&#64;#$%^&*()\-_=+{{
        '{}'
      }};:,&lt;.&gt
    </div>
  </div>
  <div class="my-4">
    <mat-form-field
      class="w-full"
      [subscriptSizing]="'dynamic'"
      hideRequiredMarker="true">
      <mat-label>Confirm New Password</mat-label>
      <input
        type="password"
        matInput
        formControlName="confirm_password"
        [spellcheck]="true"
        #bondFamilyLabel
        required
        (blur)="isConfirmedPassword()" />

      <mat-error
        *ngIf="
          pwForm.get('confirm_password')?.invalid &&
          pwForm.get('confirm_password')?.touched
        ">
        Passwords must match.
      </mat-error>
      <mat-error
        *ngIf="
      pwForm
          .get('confirm_password')
          ?.hasError('passwordMatch')
      ">
        Passwords must match.
      </mat-error>
    </mat-form-field>
  </div>
  <mat-dialog-actions class="flex-col items-end">
    <div class="flex justify-end w-full">
      @if (!passwordChangeInProgress()) {
        <button mat-flat-button tabindex="-1" class="bg" type="button"
                (click)="onCancel()">
          Cancel
        </button>
        <button
          mat-flat-button
          class="bg-primary text-black"
          [disabled]="disableChangeButton"
          (click)="onSubmitForChange(null)"
          type="submit"
          cdkFocusInitial>
          Change
        </button>
      } @else {
        <span>Changing Password...</span>
      }
    </div>
    <p class="recaptcha-notice text-right w-full">
      This site is protected by reCAPTCHA and the Google
      <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
      <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
    </p>
  </mat-dialog-actions>
</form>
